var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditHover = function SvgEditHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "edit-hover_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".edit-hover_svg__st0{fill:#333}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 960c-14.4 0-26-11.6-26-26s11.6-26 26-26l843.7-.2c14.4 0 26 11.6 26 26s-11.6 26-26 26L90 960zM916.6 106.2c-27.4-27.3-63.8-42.4-102.5-42.4s-75.1 15-102.5 42.4L245 572.8l-.5.5-.4.4c-2.7 3-4.8 6.6-5.9 10.7l-62.4 230.7c-2.5 9 .1 18.6 6.7 25.2 5 4.9 11.6 7.6 18.4 7.6 2.3 0 4.6-.3 6.8-.9l229.9-62.4c4.5-1.1 8.7-3.4 12.3-6.9L883.6 344c.4-.4.8-.7 1.2-1.1s.8-.9 1.2-1.3l30.6-30.6c56.5-56.4 56.5-148.3 0-204.8zM431.5 722.7 300.1 591.3l398.1-398.1 131.4 131.4-398.1 398.1zm-154.8-81.3 52.4 52.3 52.4 52.4L237.9 785l38.8-143.6zm603-366.9-13.3 13.3L735 156.4l13.3-13.3c17.6-17.5 40.9-27.2 65.7-27.2s48.2 9.7 65.7 27.2c36.2 36.2 36.2 95.2 0 131.4z",
    className: "edit-hover_svg__st0"
  })));
};
export default SvgEditHover;